export const initTabs = () => {
  for (const tab of document.getElementsByClassName('tabs__tab')) {
    tab.addEventListener('click', switchActiveTab);
  }
  for (const tabContent of document.getElementsByClassName('tabs__tab-content')) {
    if (parseInt(tabContent.getAttribute('data-tabid')) === 1) {
      tabContent.style.display = 'block';
    }
  }

  openAnchoredTab();
};

const switchActiveTab = event => {
  event.preventDefault();
  for (const tab of event.target.parentElement.getElementsByClassName('tabs__tab')) {
    tab.classList.remove('--active');
  }
  event.target.classList.add('--active');

  //find tab parent
  let tabParent = event.target.parentElement;
  do {
    tabParent = tabParent.parentElement;
  }
  while (!tabParent.classList.contains('tabs__tab-group'));


  for (const tabContent of tabParent.getElementsByClassName('tabs__tab-content')) {
    tabContent.style.display = 'none';
    if (parseInt(tabContent.getAttribute('data-tabid')) === parseInt(event.target.getAttribute('data-tabid'))) {
      tabContent.style.display = 'block';
    }
  }
};

const openAnchoredTab = () => {
  let anchor = decodeURI(window.location.hash);

  if (anchor.length > 0) {
    anchor = anchor.substr(1, anchor.length);

    for (const tab of document.getElementsByClassName('tabs__tab')) {
      if (tab.getAttribute('data-tabtitle') === anchor) {

        for (const otherTab of tab.parentElement.getElementsByClassName('tabs__tab')) {
          otherTab.classList.remove('--active');
        }
        tab.classList.add('--active');
        window.scrollTo(0, tab.scrollTop);
      }
    }
  }
};
